import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppProvider } from './features/AppContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import HomeOnline from './pages/HomeOnline';
import CourseRegistration from './pages/CourseRegistration';
import CourseRegistrationSuccess from './pages/CourseRegistrationSuccess';
import ViewPersonalInfo from './pages/Personal Information/ViewPersonalInfo';
import Login from './pages/Login';
import ViewAccomodation from './pages/Accomodation/ViewAccomodation';
import CreateAccomodation from './pages/Accomodation/CreateAccomodation';
import CreateTransportation from './pages/Transportation/CreateTransportation';
import ViewTransportation from './pages/Transportation/ViewTransportation';
import CreateInterview from './pages/Interview/CreateInterview';
import ViewPassportInfo from './pages/PassportInfo/ViewPassportInfo';
import CreatePassportInfo from './pages/PassportInfo/CreatePassportInfo';
import { PublicRoutes } from './routing/publicRoutes';
import { PrivateRoutes } from './routing/privateRoutes';
import ViewInterview from './pages/Interview/ViewInterview';
import SubmitInterviewQuestion from './pages/Interview/SubmitInterviewQuestion';
import PaymentSuccess from './pages/Accomodation/PaymentSuccess';
import ChangeToSingleRoom from './pages/Accomodation/ChangeToSingleRoom';
import LoginSingleRoom from './pages/LoginSingleRoom';
import ViewExperience from './pages/Personal Information/ViewExperience';
import CreateExperience from './pages/Personal Information/CreateExperience';
import LoginOnline from './pages/LoginOnline';
import { OnlinePrivateRoutes } from './routing/onlinePrivateRoutes';
import ViewOnlinePersonalInfo from './pages/Personal Information/ViewOnlinePersonalInfo';
import ViewAttendance from './pages/Attendance/ViewAttendance';
import CreateHealthDeclaration from './pages/HealthDeclaration/CreateHealthDeclaration';
import SearchEligibility from './pages/SearchEligibility';

const base_url = process.env.REACT_APP_BASE_URL;

function App() {

  return (
    // <AppProvider>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop
        // closeOnClick
        // rtl={false}
        // pauseOnFocusLoss
        // draggable
        // pauseOnHover
        />
        <Routes>
          <Route path='/retreat-my/' element={<Layout />}>
            <Route index element={<PrivateRoutes><Home /></PrivateRoutes>} />
            <Route path={`${base_url}/login`} element={<PublicRoutes><Login /></PublicRoutes>} />
            <Route path={`${base_url}/online-login`} element={<PublicRoutes><LoginOnline /></PublicRoutes>} />
            <Route path={`${base_url}/course_registration`} element={<CourseRegistration />} />
            <Route path={`${base_url}/course_registration_success`} element={<CourseRegistrationSuccess />} />
            <Route path={`${base_url}/search_eligibility`} element={<SearchEligibility />} />
            <Route path={`${base_url}/online-home`} element={<OnlinePrivateRoutes><HomeOnline /></OnlinePrivateRoutes>} />
            <Route path={`${base_url}/online-personal-info`} element={<OnlinePrivateRoutes><ViewOnlinePersonalInfo /></OnlinePrivateRoutes>} />
            <Route path={`${base_url}/view-personal-info`} element={<PrivateRoutes><ViewPersonalInfo /></PrivateRoutes>} />
            <Route path={`${base_url}/passport-info`} element={<PrivateRoutes><ViewPassportInfo /></PrivateRoutes>} />
            <Route path={`${base_url}/submit-passport`} element={<PrivateRoutes><CreatePassportInfo /></PrivateRoutes>} />
            <Route path={`${base_url}/view-accommodation`} element={<PrivateRoutes><ViewAccomodation /></PrivateRoutes>} />
            <Route path={`${base_url}/change_to_single_room`} element={<PrivateRoutes><ChangeToSingleRoom /></PrivateRoutes>} />
            <Route path={`${base_url}/retreat-accommodation`} element={<PrivateRoutes><CreateAccomodation /></PrivateRoutes>} />
            <Route path={`${base_url}/payment-success`} element={<PaymentSuccess />} />
            <Route path={`${base_url}/retreat-transportation`} element={<PrivateRoutes><CreateTransportation /></PrivateRoutes>} />
            <Route path={`${base_url}/view-transportation`} element={<PrivateRoutes><ViewTransportation /></PrivateRoutes>} />
            <Route path={`${base_url}/retreat-interview`} element={<PrivateRoutes><CreateInterview /></PrivateRoutes>} />
            <Route path={`${base_url}/view-interview`} element={<PrivateRoutes><ViewInterview /></PrivateRoutes>} />
            <Route path={`${base_url}/retreat-interview-question`} element={<PrivateRoutes><SubmitInterviewQuestion /></PrivateRoutes>} />
            <Route path={`${base_url}/loginSingleRoom`} element={<PublicRoutes><LoginSingleRoom /></PublicRoutes>} />
            <Route path={`${base_url}/retreat_experience`} element={<PrivateRoutes><CreateExperience /></PrivateRoutes>} />
            <Route path={`${base_url}/online_retreat_experience`} element={<OnlinePrivateRoutes><CreateExperience /></OnlinePrivateRoutes>} />
            <Route path={`${base_url}/view_experience`} element={<PrivateRoutes><ViewExperience /></PrivateRoutes>} />
            <Route path={`${base_url}/online_view_experience`} element={<OnlinePrivateRoutes><ViewExperience /></OnlinePrivateRoutes>} />
            <Route path={`${base_url}/view_attendance`} element={<OnlinePrivateRoutes><ViewAttendance /></OnlinePrivateRoutes>} />
            <Route path={`${base_url}/health_declaration`} element={<PrivateRoutes><CreateHealthDeclaration /></PrivateRoutes>} />
          </Route>
        </Routes>
      </BrowserRouter >
    // </AppProvider>
  );
}

export default App;
